<template>
  <div class="lead-flow-row-menu" @click.stop>
    <button
      class="lead-flow-row-menu__trigger"
      type="button"
      aria-label="Communication actions"
      :disabled="pending"
      @click="open = !open"
    >
      •••
    </button>
    <div v-if="open" class="lead-flow-row-menu__items">
      <template v-if="!confirmingDelete">
        <button type="button" @click="edit">Edit</button>
        <button class="lead-flow-row-menu__delete" type="button" @click="confirmingDelete = true">
          Delete
        </button>
      </template>
      <template v-else>
        <p>Delete this record?</p>
        <div>
          <button type="button" @click="confirmingDelete = false">Cancel</button>
          <button class="lead-flow-row-menu__delete" type="button" @click="remove">
            {{ pending ? 'Deleting...' : 'Delete' }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeadFlowCommunicationRowMenu',
  props: {
    pending: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false,
      confirmingDelete: false
    }
  },
  methods: {
    edit() {
      this.open = false
      this.$emit('edit')
    },
    remove() {
      if (this.pending) return
      this.$emit('delete')
    }
  }
}
</script>

<style scoped>
.lead-flow-row-menu {
  position: relative;
}

.lead-flow-row-menu__trigger {
  padding: 0 3px;
  border: 0;
  background: transparent;
  color: #758281;
  font-size: 11px;
  letter-spacing: 1px;
  cursor: pointer;
}

.lead-flow-row-menu__items {
  position: absolute;
  z-index: 7;
  right: 0;
  bottom: calc(100% + 5px);
  display: grid;
  width: 150px;
  gap: 3px;
  padding: 6px;
  border: 1px solid #dfe4dd;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 7px 20px rgba(30, 50, 45, .13);
}

.lead-flow-row-menu__items > button,
.lead-flow-row-menu__items > div button {
  padding: 7px 8px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #526264;
  font-size: 10px;
  text-align: left;
  cursor: pointer;
}

.lead-flow-row-menu__items > button:hover {
  background: #f3f6f1;
}

.lead-flow-row-menu__items p {
  margin: 2px;
  color: #5b6a69;
  font-size: 10px;
}

.lead-flow-row-menu__items > div {
  display: flex;
  justify-content: flex-end;
}

.lead-flow-row-menu__items > div button {
  padding: 6px;
}

.lead-flow-row-menu__delete {
  color: #b0524b !important;
}
</style>
